import styled from 'styled-components';

import Link from 'components/link';

export const TermsLink = styled(Link)`
  &::after {
    content: ', ';
  }
  &:last-child::after {
    content: '';
  }
`;
export const TermsText = styled.span`
  &::after {
    content: ', ';
  }
  &:last-child::after {
    content: '';
  }
`;

export const OptInLabel = styled.span`
  display: block;
`;
